import { render, staticRenderFns } from "./BillLoadSectionTable.vue?vue&type=template&id=5e8074f6&scoped=true"
import script from "./BillLoadSectionTable.vue?vue&type=script&lang=js"
export * from "./BillLoadSectionTable.vue?vue&type=script&lang=js"
import style0 from "./BillLoadSectionTable.vue?vue&type=style&index=0&id=5e8074f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8074f6",
  null
  
)

export default component.exports